import { VFC } from 'react'
import { Routes, Route } from 'react-router-dom'

import { PrivateRoutes } from 'infrastructure/shared/components'

import EmbedContainer from './Embed/Container'

const MasterdataRoutes: VFC = () => {
  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route path=':workflowUuid/:objectUuid' element={<EmbedContainer />} />
      </Route>
    </Routes>
  )
}

export default MasterdataRoutes
